export class BucketBrowserFolder {
  name: string = '';
  path: string = '';
  count: number = 0;

  constructor(name: string, path: string, count: number) {
    this.name = name;
    this.path = path;
    this.count = count;
  }
}